import React, { useState, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Stack, Typography } from '@mui/material'

import { FaTimes } from "react-icons/fa"
import { ImEnlarge } from "react-icons/im"

import PopupModal from 'Shared/Components/PopupModal'
import { streamingUrl } from 'Shared/utils'
import "./style.css"

const IFrameWrapper = ({ project, token, mode, stream_route }) => {
  const [streamingParams, setStreamingParams] = useState(`project=${project}&token=${token}`)

  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      try {
        const iframeWindow = iframeRef.current.contentWindow;
        const url = new URL(iframeWindow.location.href);

        url.searchParams.set("token", token);

        iframeWindow.history.replaceState({}, '', url.pathname + url.search);
      } catch (error) {
        setStreamingParams(`project=${project}&token=${token}`)
      }
    }
  }, [token])

  return (
    <iframe ref={iframeRef} src={`${streamingUrl}/${mode}/${stream_route}/?${streamingParams}`} style={{ width: "100%", height: "100%", pointerEvents: "none" }} />
  )
}

const Player = ({ clearStream, item, mode = "streaming", isVisible, token }) => {
  const { project } = useParams()

  const [open, setOpen] = useState()
  const [hovered, setHovered] = useState(false);

  return (<>
    <div style={{ width: "100%", height: "100%", display: "flex", flexFlow: "column" }} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <div style={{ width: "100%", height: "100%", position: "relative", display: "inlineBlock", flexFlow: "column", overflow: "hidden" }}>
        {(item != null) && <>
          <Stack className={`streamheader ${hovered ? "visible" : ""}`} justifyContent="space-between" direction="row">
            <Typography sx={{ display: '-webkit-box', overflow: 'hidden', WebkitBoxOrient: 'vertical', WebkitLineClamp: 1 }}>{item ? item[1] : '\u00a0'}</Typography>
          </Stack>

          <Stack  className={`streamheaderBtn ${hovered ? "visible" : ""}`} justifyContent="space-between" direction="row">
            <Stack direction="row" spacing={1}>
              <ImEnlarge size={12} style={{ color: "white", marginTop: "auto", marginBottom: "auto" }} onClick={() => setOpen(true)}/>
              <FaTimes size={15} style={{ color: "white", marginTop: "auto", marginBottom: "auto" }} onClick={() => clearStream()}/>
            </Stack>
          </Stack>
        </>}

        <div style={{ width: "100%", height: "100%" }}>
          {(item != null && isVisible === true) ? (
            <IFrameWrapper project={project} token={token} mode={mode} stream_route={item[0]}/>
          ) : (
            <div style={{ width: "100%", height: "100%", backgroundColor: "black" }}></div>
          )}
        </div>
      </div>
    </div>

    <PopupModal width="80%" height="80%" isOpen={open} close toggle={() => setOpen(false)}>
      {open && <>
        {isVisible === true && 
          <div style={{ overflow: "hidden", width: "100%", height: "100%" }}>
            <IFrameWrapper project={project} token={token} mode={mode} stream_route={item[0]}/>
          </div>
        }
      </>
      }
    </PopupModal>
  </>)
}

export default Player
